/**
 * Logger utility that only logs in development mode.
 * Provides a consistent logging interface across the application
 * while preventing console output in production builds.
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Log an informational message. Only outputs in development.
 * @param  {...any} args - Arguments to log.
 */
export const log = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

/**
 * Log a warning message. Only outputs in development.
 * @param  {...any} args - Arguments to log.
 */
export const warn = (...args) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

/**
 * Log an error message. Only outputs in development.
 * @param  {...any} args - Arguments to log.
 */
export const error = (...args) => {
  if (isDevelopment) {
    console.error(...args);
  }
};

/**
 * Log debug information. Only outputs in development.
 * @param  {...any} args - Arguments to log.
 */
export const debug = (...args) => {
  if (isDevelopment) {
    console.debug(...args);
  }
};

const logger = { log, warn, error, debug };

export default logger;
